import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
    moveCircumPoint = "MOVE_CIRCUMFERENCE_POINT",
    setTangentType = "SET_TANGENT_TYPE"
}

export const eventBus = new EventEmitter();